import httpService from "./httpService";
import { getBaseUrl } from "../helpers/baseUrlHelper";

const OrderProcessingService = {
	processOrder: async (correctionPayload, countryCode) => {
		//Make API call here (intract with server component and get the actual response)
		const baseUrl = getBaseUrl();

		return httpService
			.post(baseUrl + `correction?countryCode=${countryCode}`, {
				body: correctionPayload,
				useAuth: true
			})
			.then(response => {
				console.log(response);
				return response;
			})
			.catch(error => {
				console.log(error);
				return Promise.reject(error);
			});
	}
};

export default OrderProcessingService;
